import { useFlags } from '@atlaskit/flag';
import ApiService from 'core/api/api.service';
import { IUser } from 'core/api/users/users-api-interface';
import { FirebaseFunctionNames } from 'core/constants/firebase-function-names';
import { useDialog } from 'core/providers/DialogProvider';
import { showErrorFlag } from 'core/utilities/flags-helper';
import UserPasswordResetDialog from 'modules/auth/set-password-dialog/user-reset-password-dialog';
import { useState } from 'react';
import SharedButton from 'shared/components/buttons/button';

interface IUsersListResetPasswordButton {
  user: IUser;
}

const UsersListResetPasswordButton = ({ user }: IUsersListResetPasswordButton) => {
  const [loading, setLoading] = useState(false);
  const dialog = useDialog();
  const flags = useFlags();

  const resetPassword = async () => {
    try {
      setLoading(true);
      const temporaryPassword = await ApiService.callFunction<string>(
        { uid: user.uid },
        FirebaseFunctionNames.RESET_USER_PASSWORD
      );
      setLoading(false);
      dialog?.openDialog(<UserPasswordResetDialog temporaryPassword={temporaryPassword} fullName={user.fullName} />);
    } catch (error) {
      showErrorFlag('An error occurred', 'Could not reset user password, please try again.', flags);
      setLoading(false);
    }
  };

  return (
    <SharedButton
      isLoading={loading}
      onClick={() => resetPassword()}
      type='button'
      appearance='primary'
      label='Reset Password'
    />
  );
};

export default UsersListResetPasswordButton;
